import ChatDemo, { ChatStep } from './ChatDemo';

/**
 * MCP Server 섹션 데모.
 * 사용자가 자연어로 물으면 LLM 이 공공서비스·공공데이터 도구를 호출(tool-calling)하고
 * 실시간 데이터로 답하는 과정을 스크립트로 재생한다.
 */
const SCRIPT: ChatStep[] = [
  { kind: 'user', text: '이번 주말 양재 체육관 예약 가능한 시간 알려줘. 날씨도 같이.' },
  { kind: 'tools', tools: ['reserve_facility()', 'weather()', 'air_quality()', 'subway()'] },
  {
    kind: 'bot',
    text: '토요일 14:00 · 16:00 두 타임이 비어 있어요. 그날 양재 일대는 맑음(미세먼지 좋음)이고, 3호선 양재역에서 도보 5분입니다.',
    chips: ['공유시설 예약', '일기예보', '미세먼지', '지하철 실시간'],
  },
];

export default function McpChatDemo() {
  return (
    <ChatDemo
      title="MCP Playground"
      variant="qa"
      script={SCRIPT}
      caption="자연어 질의 → 도구 호출(tool-calling) → 실시간 공공데이터로 응답"
    />
  );
}
